import React, {useMemo} from 'react';
import {connect, useSelector} from 'react-redux';
import {FormattedNumber, useIntl} from 'react-intl';
import Big from "big.js";

const reducer = (state: any)=>state.settings.default_currency || "USD"
function CurrencyNumber({currency, asNumber, privacyMode, value}:{
    currency?: string,
    asNumber?: boolean
    privacyMode?: boolean,
    value: number
}) {
    const default_currency = useSelector(reducer)
    const currencyRatesMap = useSelector((state: any)=>state.settings.currencyRatesMap)
    const currencyDisplay = useSelector((state: any)=>state.settings.currency_display)

    const v = useMemo(()=>{
        let val = value ? Number(value) : 0 || 0
        if(currencyRatesMap && default_currency && currency && default_currency !== currency && currencyRatesMap[currency] && currencyRatesMap[default_currency]){
            return Big(val).times(currencyRatesMap[currency] || 1).div(currencyRatesMap[default_currency] || 1).toNumber()
        }
        return val;
    },[value, currencyRatesMap, default_currency, currency])
    if(privacyMode){
        return <>***</>
    }
    if(asNumber){
        return  <FormattedNumber value={v}/>
    }
    const cur = currency || default_currency;
    if(cur=== "PTS") return <RenderPTS value={v} />
    return (
        <>
            <FormattedNumber
                currencyDisplay={currencyDisplay ||  "narrowSymbol"}
                style={"currency"}
                currency={cur}
                trailingZeroDisplay={'stripIfInteger'}
                value={v}/>
        </>
    );
}
function RenderPTS({value}:{value: number}){
    const intl = useIntl()

    if (value % 1 === 0){
        return (
            <>
                <span
                    className={"pts_currency_symbol"}>{intl.formatMessage({id: "PTS"})}&nbsp;</span>
                <FormattedNumber
                    minimumFractionDigits={0}
                    maximumFractionDigits={0}
                    value={value}/>
            </>
        );
    }
    return (
        <>
            <span
                className={"pts_currency_symbol"}>
                {intl.formatMessage({id:"PTS"})}&nbsp;</span>
            <FormattedNumber
                minimumFractionDigits={0}
                maximumFractionDigits={0}
                value={value}/>
        </>
    );}

const mapStateToProps = (state, props) => ({
    currency: props.currency || (state.settings.default_currency || 'USD'),
    privacyMode: state.settings.privacyMode,
});

export default connect(mapStateToProps)(CurrencyNumber);
